export function calculateProgress(current, total) {
  if (!total || total <= 0) return 0;

  return Math.round((current / total) * 100);
}

export function calculateAccuracy(correct, total) {
  if (!total || total <= 0) return 0;

  return Math.round((correct / total) * 100);
}

export function calculateAccuracyFromErrors(
  correct,
  errors
) {
  const total = correct + errors;

  if (!total) return 0;

  return Math.round((correct / total) * 100);
}

export function calculateAverageReactionTime(
  responses = []
) {
  const validResponses = responses.filter(
    (response) =>
      Number.isFinite(Number(response.reactionTime))
  );

  if (validResponses.length === 0) return 0;

  const totalTime = validResponses.reduce(
    (total, response) =>
      total + Number(response.reactionTime),
    0
  );

  return Math.round(
    totalTime / validResponses.length
  );
}

export function calculateAverageFromValues(
  values = []
) {
  const validValues = values
    .map(Number)
    .filter((value) => Number.isFinite(value));

  if (validValues.length === 0) return 0;

  const total = validValues.reduce(
    (accumulator, value) =>
      accumulator + value,
    0
  );

  return Math.round(total / validValues.length);
}

export function calculateTotalTime(
  startTime,
  endTime
) {
  if (!startTime || !endTime) return 0;

  return Math.round(
    (endTime - startTime) / 1000
  );
}

export function calculateSelectionAccuracy({
  correctSelections = 0,
  wrongSelections = 0,
  omissions = 0,
}) {
  const total =
    correctSelections +
    wrongSelections +
    omissions;

  if (!total) return 0;

  return Math.round(
    (correctSelections / total) * 100
  );
}

export function calculateErrorCount(...errors) {
  return errors.reduce((total, value) => {
    const numericValue = Number(value);

    return Number.isFinite(numericValue)
      ? total + numericValue
      : total;
  }, 0);
}